import { PayloadAction } from '@reduxjs/toolkit';
import { RegistrationSliceState } from '../state';
import { RegistrationType } from '../../types/registrationTypes';
import { createDefaultRegistration } from '../../createDefaultRegistration';

/**
 * Initialize a new registration with default values
 */
export const initializeRegistration = (state: RegistrationSliceState) => {
  state.currentRegistration = createDefaultRegistration();
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};

/**
 * Update the current registration with partial data
 */
export const updateRegistration = (
  state: RegistrationSliceState,
  action: PayloadAction<Partial<RegistrationType>>
) => {
  if (state.currentRegistration) {
    state.currentRegistration = { ...state.currentRegistration, ...action.payload };
    state.isEdited = true;
  }
};

/**
 * Clear the current registration
 */
export const clearRegistration = (state: RegistrationSliceState) => {
  state.currentRegistration = null;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};
